import * as React from "react";
import { styled } from "@mui/system";
import Tabs from "@mui/base/TabsUnstyled";
import TabsList from "@mui/base/TabsListUnstyled";
import TabPanel from "@mui/base/TabPanelUnstyled";
import Tab from "@mui/base/TabUnstyled";
import { buttonClasses } from "@mui/material/Button";
import { tabClasses } from "@mui/material/Tab";

export default function UnstyledTabsCustomized(props) {
  const { value, onChange, data, defaultValue } = props;
  return (
    <StyledTabPanel
      defaultValue={defaultValue}
      value={value}
      onChange={onChange}
    >
      <StyledTabsList>
        {data.map((_el) => {
          return (
            <>
              <StyledTab value={_el.value} label={_el.label}>
                {_el.label}
              </StyledTab>
            </>
          );
        })}
      </StyledTabsList>
    </StyledTabPanel>
  );
}

const blue = {
  50: "#e7fbf5",
  100: "#b7f2e1",
  200: "#86eacd",
  300: "#56e2b8",
  400: "#26d9a4",
  500: "#1da980",
  600: "#15795b",
  700: "#0d4837",
  800: "#041812",
};

const grey = {
  50: "#f6f8fa",
  100: "#eaeef2",
  200: "#d0d7de",
  300: "#afb8c1",
  400: "#8c959f",
  500: "#6e7781",
  600: "#57606a",
  700: "#424a53",
  800: "#32383f",
  900: "#24292f",
};

const StyledTab = styled(Tab)`
  font-family: IBM Plex Sans, sans-serif;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: bold;

  width: auto;
  padding: 8px;
  margin: 6px 5px;
  border: none;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  min-width: 150px;
  background-color: ${blue[400]};
  color: white;
  &:hover {
    background-color: ${blue[300]};
  }

  &:focus {
    color: #fff;
    outline: 3px solid ${blue[200]};
  }

  &.${tabClasses.selected} {
    background-color: white;
    color: ${blue[600]};
  }

  &.${buttonClasses.disabled} {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const StyledTabPanel = styled(Tabs)`
  width: min-content;
  font-family: IBM Plex Sans, sans-serif;
  font-size: 0.875rem;
`;

const StyledTabsList = styled(TabsList)(
  ({ theme }) => `
  min-width: 100px;
  background-color: ${blue[400]};
  border-width: 2px;
  border-radius: 25px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: space-between;
  transition: 'transform 0.3s ease',

  box-shadow: 0px 4px 8px ${
    theme.palette.mode === "dark" ? grey[900] : grey[200]
  };
  `
);
